import { useEffect, useState } from 'react';
import Progress from 'antd/es/progress';

type CountUpTimerProps = {
  countFrom: number;
  duration: number;
  handleTimeout: () => void;
}

export const CountUpTimer = ({ countFrom, duration, handleTimeout }: CountUpTimerProps) => {
  const [time, setTime] = useState(countFrom);

  useEffect(() => {
    if (time >= duration) {// Stop if the time reaches the duration
      handleTimeout()
      return;
    }
    const timerId = setInterval(() => {
      setTime((prevTime) => prevTime + 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [time, duration]);

  const formatTime = (timeInSeconds: number) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className='flex flex-col mx-3 mr-8 mb-4'>
      <div className='flex justify-between' >
        <div>{formatTime(time)}</div>
        <div>{formatTime(duration)}</div>
      </div>
      <Progress
        percent={Math.floor(time / duration * 100)}
        percentPosition={{ align: 'start', type: 'outer' }}
        className='text-primary w-[20rem]' showInfo={false}
        strokeColor={{ from: '#F17A20', to: 'red' }}
        size="small"
      />

    </div>
  );
};